export default {
	notes: {
		visibleUntil: 'visible until',
		visibleFor: 'Visible for',
		title: 'News / Notes',
		noteLink: 'Notification / Linking',
		linking: 'Linking',
		noteType: '@:entity.notestype.name',
		author: 'Author',
		start: 'Start',
		end: 'End',
		addressDescription: 'Address Description',
		dataProcessingResponsibility:
			'You are responsible for data processing. Please independently verify whether you are permitted to send this message to recipients by email from a data protection perspective, e.g., for the purpose of fulfilling the management contract. Users who have activated Mobile access and those who have not (indicated by the red !) may differ in this regard. If in doubt, please consult your data protection advisors. This notice does not constitute legal advice on data protection.',
		noDispatch: 'No dispatch',
		mobileUsersActivated: 'Activated MOBILE users',
		sendingDisabled:
			'Sending of notifications is disabled, please enable it first to use this feature',
		recipient: '@:common.recipient',
		addressAccess:
			'To select a property management / address as the author, it must have a valid user account.',
		documentSizeWarning:
			'The total size of the documents exceeds 20 MB. Therefore, documents will not be sent as an attachment with the notification!',
		editNoteRecipient: 'Edit note recipient',
		transfer: 'Transfer',
		transferNotice:
			"Selecting 'Transfer to Z.I.S.' requires selecting at least one object. In the next step, you will only be able to select one document.",
		transferButton: 'Transfer to Z.I.S. HP Genesis',
		documentsWithObjects:
			'Documents with the specified objects @.lower:{action}',
	},
}
